export enum PreApprovalStatus {
  Approved = 'Approved',
  Declined = 'Declined',
}
